import { ValideringsResultat } from '../../../Shared/Scripts/Models/ValideringsResultat';

export type ResultatValg = ResultatValgVisning & ResultatValgValidering;

export interface ResultatValgVisning {
    visBoksB: boolean;
    visBoksBx: boolean;
    visBoksC: boolean;
    visBoksCx: boolean;
    visBoksE: boolean;
    visBoksF: boolean;
    visResultat: boolean;
    visFordeling: boolean;
    visGenerellFeil: boolean;
}

export interface ResultatValgValidering {
    cValidation?: ValideringsResultat;
    cXValidation?: ValideringsResultat;
    fValidation?: ValideringsResultat;
}

export const UPDATE_VALIDERING = 'UPDATE_VALIDERING';
export const SET_VISNING = 'SET_VISNING';

export interface UpdateValidationAction {
    type: typeof UPDATE_VALIDERING;
    payload: Partial<ResultatValgValidering>;
}

export interface SetVisningAction {
    type: typeof SET_VISNING;
    payload: Partial<ResultatValgVisning>;
}

export type ResultatActionTypes = SetVisningAction | UpdateValidationAction;
